import { inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { firstValueFrom } from 'rxjs';

import { GqlService, PatientGroupType } from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectPatientProtocolSubTypes = () => {
  const mainQuery = inject(MainQuery);
  const gqlService = inject(GqlService);

  return injectQuery(() => ({
    queryFn: () => firstValueFrom(gqlService.listPatientProtocolSubTypes$([])),
    queryKey: ['patientProtocolSubTypes', mainQuery.trialKey()],
  }));
};

export const injectPatientGroups = ({
  patientGroupTypes = [],
}: {
  patientGroupTypes?: PatientGroupType[];
}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);
  const overlayService = inject(OverlayService);

  return injectQuery(() => ({
    onError: (error: string[]) => {
      overlayService.error(error);
    },
    queryFn: async () => {
      const response = await gqlToPromise(() =>
        gqlService.listPatientGroups$(
          patientGroupTypes || [
            PatientGroupType.PATIENT_GROUP_FORECAST_ONLY,
            PatientGroupType.PATIENT_GROUP_STANDARD,
          ]
        )
      );

      return response;
    },
    queryKey: ['trials', mainQuery.trialKey(), 'patient-groups', patientGroupTypes],
  }));
};
